import { C } from "./constants";

export const ini = (n) => String(n || "").split(" ").filter(Boolean).map(x=>x[0]).join("").slice(0,2).toUpperCase();

export const isPremiumWorker = (w) => ["premium", "pro"].includes(String(w.plan || "").toLowerCase());

export const normalizeMode = (value) => {
  const v = String(value || "cliente").toLowerCase();
  return v.includes("trabajador") ? "trabajador" : "cliente";
};

export const ficioCleanPhone = (value) => String(value || "").replace(/\D/g, "");

export const clearFicioStorage = () => {
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith("sb-") || k.startsWith("ficio") || k === "supabase.auth.token")
      .forEach(k => localStorage.removeItem(k));
    sessionStorage.clear();
  } catch(_) {}
};

const MAX_FILE_MB = 5;
const ALLOWED_IMG_TYPES = ["image/jpeg","image/jpg","image/png","image/webp","image/heic","image/heif"];

export const validateImageFile = (file, label = "Archivo") => {
  if (!file || !(file instanceof File)) return null;
  if (!ALLOWED_IMG_TYPES.includes(file.type.toLowerCase()))
    return `${label}: solo se aceptan imágenes JPG, PNG o WebP`;
  if (file.size > MAX_FILE_MB * 1024 * 1024)
    return `${label}: el archivo no puede superar ${MAX_FILE_MB}MB`;
  return null;
};

export const ficioWorkerIdentity = (workerLike) => {
  const w = workerLike || {};
  return String(
    w.user_id ||
    w.id ||
    ficioCleanPhone(w.telefono || w.phone || w.whatsapp) ||
    `${w.nombre || w.name || "trabajador"}-${w.oficio || w.trade || "oficio"}-${w.ciudad || w.zona || w.zone || "Los Mochis"}`
  ).toLowerCase();
};

export const adaptWorker = (t = {}) => {
  const name = t.nombre || t.name || "Trabajador";
  const phone = t.telefono || t.phone || t.whatsapp || "";
  const trade = t.oficio || t.trade || "";
  const zone = t.ciudad || t.zona || t.zone || "Los Mochis";
  const reviews = t["reseñas"] ?? t.resenas ?? t.reviews ?? 0;
  const jobs = t.trabajos ?? t.jobs ?? t.total_trabajos ?? 0;
  return {
    id: t.id,
    name,
    nombre: name,
    phone,
    telefono: phone,
    whatsapp: t.whatsapp || phone,
    trade,
    oficio: trade,
    specialty: t.especialidad || t.specialty || "",
    especialidad: t.especialidad || t.specialty || "",
    zone,
    zona: zone,
    ciudad: zone,
    exp: t.exp || 0,
    rating: t.calificacion ?? t.rating ?? 0,
    reviews,
    jobs,
    avatar: t.foto_url || t.avatar || ini(name || "T"),
    foto_url: t.foto_url || "",
    ineUrl: t.ine_url || "",
    available: t.disponible ?? t.available ?? true,
    verified: t.verificado ?? t.verified ?? false,
    badges: t.badges || [],
    plan: t.plan || "basico",
    membresia: t.membresia || (t.membresia_activa === false ? "inactiva" : "activa"),
    membresia_activa: t.membresia_activa ?? (t.membresia !== "inactiva"),
    visible_directorio: t.visible_directorio ?? true,
    user_id: t.user_id || null,
    nuevo: t.nuevo ?? true,
    portfolio: Array.isArray(t.portfolio_urls)
      ? t.portfolio_urls.map((url, i) => ({ url, title: `Trabajo ${i + 1}`, desc: "Foto de portafolio" }))
      : (t.portfolio || []),
    clientReviews: t.client_reviews || t.clientReviews || [],
  };
};

export const adaptSupervisor = (s) => ({
  id: s.id,
  name: s.nombre || s.name || "",
  phone: s.telefono || s.phone || "",
  specialty: s.especialidad || s.specialty || "",
  exp: s.exp || 0,
  rating: s.calificacion ?? s.rating ?? 0,
  reviews: s["reseñas"] ?? s.resenas ?? s.reviews ?? 0,
  avatar: s.avatar || ini(s.nombre || s.name || "S"),
  color: s.color || C.blue,
  available: s.disponible ?? s.available ?? true,
  price: s.precio ?? s.price ?? 499,
  cedula: s.cedula || "",
});

export const mergeWorkersStable = (...lists) => {
  const seen = new Set();
  const merged = [];
  for (const list of lists) {
    for (const raw of (Array.isArray(list) ? list : [])) {
      if (!raw) continue;
      const adapted = raw.name && raw.trade ? raw : adaptWorker(raw);
      const key = ficioWorkerIdentity(adapted);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      merged.push(adapted);
    }
  }
  return merged;
};
